export type AlignType = 'left' | 'center' | 'right';
